import metadata from './block.json';
// Global import
const { registerCheckoutBlock } = wc.blocksCheckout;
/**
 * Internal dependencies
 */
import Block from './block';

const Frontend = ({ children, checkoutExtensionData }) => { 

    
    return (
        <Block className='cqoc-front-block'/>
    );
};

const options = {
	metadata,
	component: Frontend
};

registerCheckoutBlock( options );


